module.exports = __webpack_public_path__ + "static/img/12.a6c7d17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/12.png
// module id = bwZm
// module chunks = 0